import React from 'react';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';
import { useHistory } from 'react-router-dom';
import { EPurchaseRoutes } from '../../pages/Purchase/purchase.routes';
import { getTaggingInformationScreen } from '../../utils/Tagging';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../store/ducks/tagging/actions';
import { ERoutes } from '../../routes';
import { EOrderSettingsRoutes } from '../../pages/Purchase/LongSteel/OrderSettingsMvp/orderSettings.routes';
import { Container } from './styles';
interface INavegationMenuBarProps {
  items: BreadcrumbItemProps[];
  notRender?: boolean;
}

const NavegationMenuBar: React.FC<INavegationMenuBarProps> = ({
  items,
  notRender
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    history.location.pathname
  );

  if (notRender) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const pathsTagging: any = {
    'steel-type-choose': 'comprar',
    'entry-type': 'comprarAcosLongos'
  };

  const fromProductDetailsToCatalog = (newPath: string): boolean => {
    return (
      history.location.pathname.includes(EOrderSettingsRoutes.PRODUCT) &&
      newPath.includes(EOrderSettingsRoutes.CATALOG)
    );
  };
  return (
    <Container>
      <Breadcrumbs
        breadcrumbItems={items}
        onClick={(path: string) => {
          dispatch(
            sendTagging({
              screenName,
              itemDescription: `${itemDescription}_${pathsTagging[path]}`,
              itemName: `button:${pathsTagging[path]}`,
              event: 'click_filter'
            })
          );

          if (path.includes(EPurchaseRoutes.STEEL_TYPE_CHOOSE)) {
            history.replace(
              `${ERoutes.PURCHASE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
            );
            return;
          }

          if (fromProductDetailsToCatalog(path)) {
            const newPath = `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${EPurchaseRoutes.COMMERCE}/${EOrderSettingsRoutes.CATALOG}`;
            history.replace(newPath);
            return;
          }
          history.push(path);
        }}
      ></Breadcrumbs>
    </Container>
  );
};

export default NavegationMenuBar;
